import Footer from "components/VerticalLayout/Footer";
import React from "react";
import { Container, Card } from "reactstrap";

const Termscondition = () => {
    return (
        <React.Fragment >
            <div
                style={{
                    backgroundColor: "#121212",
                    color: "#fff",
                    minHeight: "100vh",
                    padding: "50px 20px",
                }}
            >
                <Container>

                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <h1 className="text-center mb-4">Terms and Conditions</h1>
                    <Card className="p-4 shadow-sm" style={{ backgroundColor: "#1e1e1e", color: "#fff" }}>
                        <p>
                            <strong>Introduction:</strong> Welcome to{" "}
                            <strong>aiinrealestate.in</strong>. These Terms and Conditions
                            ("Terms") govern your use of our website and services. By accessing
                            or using our platform, you agree to be bound by these Terms.
                        </p>
                        <p>
                            <strong>Services:</strong> We provide an online platform for users
                            to list, browse, buy, sell, and rent properties in Vadodara, Gujarat.
                            While we facilitate connections and provide information, we are not a
                            real estate broker and do not act as agents for any party unless
                            explicitly stated otherwise.
                        </p>
                        <p>
                            <strong>User Conduct:</strong> You agree to use the website for
                            lawful purposes only. You must not post false, misleading, or
                            fraudulent information. Any unauthorized use of the platform is
                            strictly prohibited.
                        </p>
                        <p>
                            <strong>Intellectual Property:</strong> All content on this site,
                            including text, graphics, and logos, is the property of{" "}
                            <strong>aiinrealestate.in</strong> or its content suppliers and is
                            protected by Indian and international copyright laws.
                        </p>
                        <p>
                            <strong>Limitation of Liability:</strong>{" "}
                            <strong>aiinrealestate.in</strong> will not be liable for any direct,
                            indirect, incidental, or consequential damages arising from the use
                            or inability to use our website or services.
                        </p>
                        <p>
                            <strong>Governing Law:</strong> These Terms are governed by and
                            construed in accordance with the laws of India. The courts in
                            Vadodara, Gujarat, will have exclusive jurisdiction over any disputes.
                        </p>
                    </Card>
                </Container>
            </div>
            {/* Footer */}
            <Footer />
        </React.Fragment >
    );
};

export default Termscondition;
